import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin } from '../../../components/molecues';
import { Button, LoadingView, Table } from '../../../../common/components/atoms';
import { ModalDialog } from '../../../../common/components/molecues';

import { NOTICE_TARGET } from '../../../common/constants.js';
import { DialogMessage } from '../../../common/DialogMessage.jsx';

class NoticeCtrl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchText: "",
            notices: [],
            displayDeleteDlg: false,
            deleteReady: null
        }
    }

    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'GetNoticeList_Saga',
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
        });
    }

    getSortedList(list) {
        list.sort((a, b) => {
            if (new Date(a.expireDate) < new Date(b.expireDate)) return -1;
            if (new Date(a.expireDate) > new Date(b.expireDate)) return 1;
            return 0;
        });
        return list;
    }

    onSuccess = (list) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.createNoticeProps(this.getSortedList(list));
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onGetNoticeList = (data) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onClickColumn = (index) => {
    }
    onClickRow = (index) => {
        this.props.dispatch({
            type: 'NoticeEdit',
            notice: this.state.notices[index],
        });
        this.props.history.push('/admin/notice-edit');
    }

    onSuccessDelete = (index) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        let notices = this.state.notices;
        notices[index].disable = true;
        this.setState({
            notices: notices,
            displayDeleteDlg: false,
        });
    }
    onClickDelete = (index) => {
        this.setState({
            displayDeleteDlg: true,
            deleteReady: index
        });
    }
    createNoticeProps(notices) {
        let notice = [];
        for(let key in notices) {
            notice.push({
                id: notices[key].id,
                expireDate: notices[key].expireDate,
                target: NOTICE_TARGET[notices[key].target],
                targetID: notices[key].targetID,
                contents: notices[key].contents,
                title: notices[key].title,
                createDate: notices[key].createDate,
                disable: notices[key].deleteFlg,
            });
        }
        this.setState({
            notices: notice
        })
    }
    createTableProps() {
        const height = (window.innerHeight - 64 - 20 - 28 - 64) + "px";
        return {
            height: height,
            columns : {
                "有効期限": "expireDate",
                "対象": "target",
                "対象ID": "targetID",
                "お知らせ": "title",
                "送信日時": "createDate",
            },
            data: this.state.notices,
            onClickColumn: this.onClickColumn,
            onClickRow: this.onClickRow,
            controls : {
                "delete" : {
                    onClick: this.onClickDelete,
                    contents: (
                    <TableContrl>
                        <i className="fas fa-trash" />
                    </TableContrl>
                    ),
                }
            }
        };
    }

    onCilckNewNotice = (e) => {
        this.props.dispatch({
            type: 'NoticeEdit',
            notice: null,
        });
        this.props.history.push('/admin/notice-edit');
    }
    onCilckBack = (e) => {
        this.props.history.push('/admin/top');
    }
    onClickDeleteCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        let index = this.state.deleteReady;
        this.props.dispatch({
            type: 'DeleteNotice_Saga',
            id: this.state.notices[index].id,
            index: index,
            onSuccess: this.onSuccessDelete,
            onFailure: this.onFailure,
        });
    }

    onClickDlgCancel = () => {
        this.setState({
            displayDeleteDlg: false,
            deleteReady: null,
        });
    }

    createDeleteDlgProps() {
        let title = this.state.deleteReady ?  this.state.notices[this.state.deleteReady].title : "";
        let message = (
            <div>
                {title}を削除します。<br/>
                よろしいですか？<br/>
            </div>
        )
        return {
            display: this.state.displayDeleteDlg,
            contents: (
                <DialogMessage key="message" Title="確認" Message={message} />
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickDeleteCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }

    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight - 64 - 20) + "px";
        const propsHeader = {
            title: "お知らせ管理",
            history: this.props.history,
        }
        const propsTable = this.createTableProps();
        const propsDeleteDlg = this.createDeleteDlgProps();
        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <Contents Width={width} Height={height}>
                    <Controls>
                        <ControlsChild>
                            <Button 
                                Color="#0077FF" 
                                Width="100px"
                                onClick={this.onCilckNewNotice}
                                icon={(<i className="fas fa-pen" />)}
                                text="新規作成" />
                            <Button 
                                Color="#888888" 
                                Width="100px"
                                onClick={this.onCilckBack}
                                text="戻る" />
                        </ControlsChild>
                    </Controls>
                    <Results>
                        <Table {...propsTable} />
                    </Results>
                </Contents>
                <ModalDialog name="delete-dialog" {...propsDeleteDlg} />
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
        afterLoadMessage: store.loading.message,
        loadResult: store.loading.state,
    }
};

const connectedNoticeCtrl = connect(mapStateToProps)(NoticeCtrl);
export { connectedNoticeCtrl as NoticeCtrl };

const Body = styled.div`
`;
const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: ${props => (props.Height)};
    padding-top: 20px;
`;
const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;
const ControlsChild = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Results = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
`;

const TableContrl = styled.div`
    cursor: pointer;
    padding: 0 2px;
`;
